let template = {
    template: "模板",
    addTemplate: "添加模版",
    editTemplate: "编辑模版",
    templateDetail: "模版详情",
    setTurnOnOffTemplate: "设置开关机模版",
    setTurnOnTemplate: "设置开机模板",
    setTurnOffTemplate: "设置关机模板",
    turnOnTemplateContent: "开机模板内容",
    turnOffTemplateContent: "关机模板内容",
    orgTemplateConfig: "机构{name}模版配置",
    deviceTemplateConfig: "设备{name}模版配置",
    status: "模板状态",
    templateName: "模板名称",
    enterTemplateName: "请输入模板名称",
    templateContent: "模板内容",
    enterTemplateContent: "请输入模板内容",
    templateNumber: "模板编号",
    templateType: "模板类型",
    languageType: "语言类型",
    selTemplateType: "请选择模板类型",
    messageTemplate: "消息模板",
    poweronTemplate: "开机模版",
    powerTemplate: "开机模版",
    poweroffTemplate: "关机模版",
    currencyTemplate: "货币单位",
    lang_cn: "中文",
    lang_en: "英语",
    lang_id: "印地语",
    lang_am: "阿姆哈拉语",
    type_prefix: "前缀",
    type_suffix: "后缀",
    printTemplate: "打印模版",
    logoTemplate: "Logo模版",
    audioType: "音频类型",
    speechSpeed: "语速",
    selSpeechSpeed: "请选择语速",
    generationType: "生成方式",
    onlineGeneration: "在线生成",
    audioFileRequired: "请上传音频文件",
    fileTypeInvalid: "请上传mp3文件",
    fileTooLarge: "文件太大，最大限制为8Kb",
    pleaseGenerateFile: "请生成文件",
    fileUpload: "文件上传",
    unaudited: "未审核",
    audited: "已审核",
    selTemplate: "请选择模版",
    reUpload: "重新上传",
    availableResources: "现有资源",
    resourceDetail: "资源详情",
    instructionSet: "指令集",
    example: "实例",
    displayPotion: "显示位置",
    selDisplayPotion: "请选择显示位置",
    alignLeft: "局左对齐",
    alignRight: "局右对齐",
    alignCenter: "局中对齐",
    marginTop: "图片距顶端距离(mm)",
    enterMarginTop: "请输入图片距顶端距离(mm)，取值0-10",
    marginBottom: "图片距底端距离(mm)",
    enterMarginBottom: "请输入图片距底端距离(mm)，取值0-10",
    logoPicUpload: "logo图片上传",
    logoCmd:{
        text: "图片LOGO",
        title: "LOGO标签，专有属性说明：ID=LOGO ID，选择此模板打印的LOGO",
    },
    tCmd: {
        text: "普通文本",
        title: "标签内可设置属性，其后的内容均按此格式",
    },
    spCmd: {
        text: "分割线",
        title: "自动打印一整行的--------------------------",
    },
    blCmd: {
        text: "空行",
        title: "插入空行"
    },
    qrCmd: {
        text: "二维码",
        title: "自动将内容转换为二维码"
    },
    barCmd: {
        text: "条形码",
        title: "自动将内容转换为条形码"
    },
    tabCmd: {
        text: "表格",
        title: "例：<TAB COL=[3,2,1]>表示3列的表格，列宽比为3:2:1，行数根据传参二维数组的长度决定"
    },
    alCmd: {
        text: "对齐方式",
        title: "1左对齐、2居中、3右对齐，默认值1"
    },
    szCmd: {
        text: "字体大小",
        title: "字号1～6依次增大，默认值2"
    },
    bdCmd: {
        text: "字体加粗",
        title: "0正常，1加粗，默认值0"
    },
    wdCmd: {
        text: "二维码宽度",
        title: "范围1~10，根据实际情况做映射，默认值6"
    },
    scCmd: {
        text: "是否在条形码底部打印可识读字符",
        title: "0打印，1不打印，默认值0"
    },
    printDisplay: {
        merchantName: "商户名称",
        testMerchant: "测试商户",
        merchantNo: "商户编号",
        terminalNo: "终端编号",
        payStatus: "支付状态",
        payFinish: "支付完成",
        payChannel: "收款方式",
        alipay: "支付宝",
        messageId: "消息  ID",
        tradeTime: "交易时间",
        tradeAmount: "交易金额",
        discountAmount: "优惠金额",
        tradeNo: "交易流水号",
        hotLine: "24小时客服热线",
    },
    max32: "模板名称最长32字符",
    max64: "模板内容最长64字符",
}

export default template
